// client/src/components/AboutPage.js
import React from 'react';
import UnderConstruction from '../../common/UnderConstruction.js';
import { useAuth } from '../../../context/AuthContext';
import { useTranslation } from 'react-i18next';


function AboutPage() {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div>
      <UnderConstruction />
      {user && <div >&copy; {new Date().getFullYear()} beinSmart.cloud. {t('footer.allRightsReserved')}</div>}
    </div>

  );
}

export default AboutPage;